module.exports = __webpack_public_path__ + "static/img/paintsplatter.8c274d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/paintsplatter.png
// module id = ErX+
// module chunks = 0